module.exports = __webpack_public_path__ + "static/media/floorplan.6eab604e.jpg";